module.exports = __webpack_public_path__ + "img/linkus-cd.737b5f00.png";